var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('router-view'),(!_vm.inPrint)?_c('div',[(_vm.showLogin)?_c('login'):_vm._e(),_c('v-alert',{attrs:{"value":(_vm.errorMessage!=''),"outlined":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.errorMessage)+" ")])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }